import type { Trials } from '../stores/slices/task-form';

/**
 * 后端下发的试用分组 key。新增一档时这里和 TRIAL_GROUP_MAP 要一起加，
 * 漏掉映射不会报错，只会让该功能的试用次数恒为 0。
 */
export type TrialGroupKey =
  | '720p'
  | 'Q1'
  | 'audio'
  | 'voice'
  | 'editor'
  | 'Q2-speed'
  | 'Q2-pro-free'
  | 'Q2-t2v'
  | 'Q2-c2v'
  | 'Q2-t2i'
  | 'Q2-r2i'
  | 'Image25-t2i-fast'
  | 'Image25-t2i-pro'
  | 'Image25-r2i-fast'
  | 'Image25-r2i-pro'
  | 'Q2-extend'
  | 'Q2-extend-pro'
  | 'Q2-video-edit'
  | 'Q3-t2v-i2v'
  | 'Q3-c2v'
  | 'Q4-540p'
  | 'Q4-720p'
  | 'Q4-1080p'
  | 'story-grid'
  | 'offline-avatar';

/** group → store 字段。单独成文件是为了能在不拉起 next-intl / apis 的情况下被测试直接引用。 */
export const TRIAL_GROUP_MAP: Record<TrialGroupKey, keyof Trials> = {
  '720p': 'trials720p',
  Q1: 'trialsQ1',
  audio: 'trialsText2Audio',
  voice: 'trialsVoice',
  editor: 'trialsProMode',
  'Q2-speed': 'trialsQ2TransitionSpeed',
  'Q2-pro-free': 'trialsQ2TransitionPro', // Q2 图生 transition 的 pro 选项（电影大片）的试用
  'Q2-t2v': 'trialsQ2T2V',
  'Q2-c2v': 'trialsQ2C2V',
  'Q2-t2i': 'trialsQ2T2I',
  'Q2-r2i': 'trialsQ2R2I',
  'Image25-t2i-fast': 'trialsImage25T2IFast',
  'Image25-t2i-pro': 'trialsImage25T2IPro',
  'Image25-r2i-fast': 'trialsImage25R2IFast',
  'Image25-r2i-pro': 'trialsImage25R2IPro',
  'Q2-extend': 'trialsQ2Extend',
  'Q2-extend-pro': 'trialsQ2ExtendPro',
  'Q2-video-edit': 'trialsQ2Pro', // Q2 pro 模型
  'Q3-t2v-i2v': 'trialsQ3T2VI2V', // Q3 文生图生
  'Q3-c2v': 'trialsQ3C2V', // Q3 参考生
  'Q4-540p': 'trialsQ4_540p',
  'Q4-720p': 'trialsQ4_720p',
  'Q4-1080p': 'trialsQ4_1080p',
  'story-grid': 'trialsStoryGrid', // 多宫格创作
  'offline-avatar': 'trialsOfflineAvatar', // 离线数字人（仅 /vidu-stream/offline/avatar 消费）
};
